<div id="error" fxLayout="column" fxLayoutAlign="start center">

    <div class="content" fxLayout="column" fxLayoutAlign="center center">
        <div class="error-image">
            <img src="./assets/images/errors/404.png" />
        </div>

        <div class="error-title mt-32">
            {{errorTitle | translate}}
        </div>

        <div class="error-message mt-6">{{errorMessage | translate}}</div>

    </div>

</div>

